import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import UndoIcon from '@material-ui/icons/Undo';

const useStyles = makeStyles(() => ({
  toolbar: {
    position: 'absolute',
    bottom: 24,
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'rgba(255, 255, 255, 0.97)',
    borderRadius: 10,
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    zIndex: 1200,
  },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: '#2e7d32',
    marginRight: 4,
  },
  btn: {
    textTransform: 'none',
    fontSize: 12,
    padding: '4px 12px',
    minWidth: 0,
  },
}));

const DrawToolbar = ({ onUndoPoint, onCancel, canUndo }) => {
  const classes = useStyles();
  return (
    <div className={classes.toolbar}>
      <span className={classes.label}>Drawing boundary</span>
      <Button
        size="small"
        variant="outlined"
        className={classes.btn}
        startIcon={<UndoIcon style={{ fontSize: 14 }} />}
        onClick={onUndoPoint}
        disabled={!canUndo}
      >
        Undo point
      </Button>
      <Button
        size="small"
        variant="outlined"
        className={classes.btn}
        startIcon={<CloseIcon style={{ fontSize: 14 }} />}
        onClick={onCancel}
        style={{ color: '#d32f2f', borderColor: '#d32f2f' }}
      >
        Cancel drawing
      </Button>
    </div>
  );
};

export default DrawToolbar;
